import React from "react";
import { Container } from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import AllPersons from "./AllPersons";
import { usePageActivity } from "Components/Hooks/UsePageActivity";
import { useLocation } from "react-router-dom";

const Persons = () => {
  const location = useLocation();
  usePageActivity(location.pathname, "Persons");

  document.title = "Persons | CIMS";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title="Persons"
            pageTitles={[{ title: "Dashboard", link: "/dashboard" }]}
          />
          <AllPersons />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Persons;
